//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

//CRYPTO
export const GET_WALLET = "/wallet";

// Crypto
export const GET_CRYPTO_ORDRER_LIST = "/crypto-order-list";

//activities
export const GET_WALLET_ACTIVITIES = "wallet-activies";

//Jobs
export const GET_JOB_LIST = "/jobs";
export const DELETE_JOB_LIST = "/delete/job";
export const ADD_NEW_JOB_LIST = "/job/add"
export const UPDATE_JOB_LIST = "/job/update"

//job grid
export const GET_JOB_GRID = "/job-grid";
//job condidate list
export const GET_CANDIDATE0_LIST = "/condidate-list";

//Apply Jobs
export const GET_APPLY_JOB = "/jobApply";
export const DELETE_APPLY_JOB = "/delete/applyjob";

export const POST_LOGIN = "https://b7e07b98-6bc2-4816-aef7-d5c76daf4a2c.mock.pstmn.io/post-login?";

export const MAP_GEO_SERVER = "https://geoserver.egazar.gov.mn/geoserver/wfs?service=wfs&version=2.0.0&request=GetFeature&typeName=geoware:landUse_123&outputFormat=application/json&viewparams=";

export const MAP_GEO_29_SAV_GAZAR = "https://geoserver.erkhet-innovation.com/geoserver/satellite/wms?service=WMS&version=1.1.0&request=GetMap&layers=satellite%3Awater_29_sav_gazar&bbox=-762975.5746999998%2C4603301.8873%2C1640191.8881%2C5795231.3867999995&width=768&height=380&srs=EPSG%3A4326&styles=&format=application/openlayers";

//LOGIN
export const AUTH_LOGIN = "/auth/login";
export const AUTH_LOGOUT = "/auth/logout";
export const AUTH_PROFILE = "/auth/profile";
